import React, {useRef} from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import RequireAuth from './components/RequireAuth';
import ScrollToTop from './components/ScrollToTop';
import Layout from './components/layout';
import Board from './components/Board';
import BoardItem from './components/BoardItem';
import BrowseNFTsPage from './pages/BrowseNFTsPage';
import Chart from './pages/Chart';
import Dashboard from './pages/Dashboard';
import Profile from './pages/Profile';
import Fun from './pages/Fun';
import MagicFlowsPage from './pages/MagicFlowsPage';
import MiniBook from './pages/MiniBook';
import MiniGame from './pages/MiniGame';
import Home from './pages/Home';
import Login from './pages/Login';
import LoggingIn from './pages/LoggingIn';
import NFTChat from './pages/NFTChat';
import PackagePage from './pages/PackagePage';
import Settings from './pages/Settings';
import ShillShack from './pages/ShillShack';
import Shop from './pages/Shop';
import UploadablesPage from './pages/UploadablesPage';
import Workspace from './pages/Workspace';
import { CheckoutForm } from './components/StripeCheckout';
import { Return } from './components/StripeCheckout';

const AppRouter = () => (
  <Router>
    <ScrollToTop />
    <Routes>
      
      {/* Routes without Layout */}
      <Route path="/login" element={<Login />} />
      <Route path="/loggingin" element={<LoggingIn />} />

      {/* Routes with Layout */}
      
      <Route path="/" element={<Layout><RequireAuth><Home /></RequireAuth></Layout>} />
      <Route exact path="/boards" element={<Layout><RequireAuth><Board /></RequireAuth></Layout>} />
      <Route path="/boards/:id" element={<Layout><RequireAuth><BoardItem /></RequireAuth></Layout>} />
      <Route path="/browsenfts" element={<Layout><BrowseNFTsPage /></Layout>} />
      <Route path="/chart" element={<Layout><RequireAuth><Chart /></RequireAuth></Layout>} />
      <Route path="/dashboard" element={<Layout><RequireAuth><Dashboard /></RequireAuth></Layout>} />
      <Route path="/magicflows" element={<Layout><RequireAuth><MagicFlowsPage /></RequireAuth></Layout>} />
      <Route path="/nftchat" element={<Layout><RequireAuth><NFTChat /></RequireAuth></Layout>} />
      <Route path="/packages" element={<Layout><RequireAuth><PackagePage /></RequireAuth></Layout>} />
      <Route path="/profile" element={<Layout><RequireAuth><Profile /></RequireAuth></Layout>} />
      <Route path="/settings" element={<Layout><RequireAuth><Settings /></RequireAuth></Layout>} />
      <Route path="/shillshack" element={<Layout><RequireAuth><ShillShack /></RequireAuth></Layout>} />
      <Route path="/shop" element={<Layout><RequireAuth><Shop /></RequireAuth></Layout>} />
      <Route path="/workspace" element={<Layout><RequireAuth><Workspace /></RequireAuth></Layout>} />
      <Route path="/checkout" element={<Layout><RequireAuth><CheckoutForm /></RequireAuth></Layout>} />
      <Route path="/return" element={<Layout><RequireAuth><Return /></RequireAuth></Layout>} />
      <Route path="/uploadables" element={<Layout><RequireAuth><UploadablesPage /></RequireAuth></Layout>} />

      <Route path="/fun" element={<Layout><Fun /></Layout>} />
      <Route path="/minibook" element={<Layout><MiniBook /></Layout>} />
      <Route path="/minigame" element={<Layout><MiniGame /></Layout>} />
    </Routes>
  </Router>
);

export default AppRouter;
